"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryButtonLink = exports.PrimaryButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
/**
 * Note that this uses a border style that matches
 * the color of the button itself. This is so that
 * it will be the same size as the secondary button.
 */
exports.PrimaryButton = (0, styled_1.default)('button') `
  && {
    cursor: pointer;
    background-color: ${(0, ui_theme_1.fromTheme)('color_button')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_button')};
    border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
    font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    text-decoration: none;
    display: inline-block;
    &:focus {
      outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
      outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
      outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
      outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
    }
    &:hover {
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
    }
    &:disabled {
      cursor: not-allowed;
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_disabled')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    }
    &:active:not(:disabled) {
      outline-color: ${(0, ui_theme_1.fromTheme)('color_button')};
      outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
      outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
      outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
      background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
      border-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
      color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
    }
  }
`;
exports.PrimaryButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.PrimaryButton, Object.assign({ as: "a" }, props)))) `
  && {
    &:visited {
      color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
    }
  }
`;
//# sourceMappingURL=primary.js.map